import React from 'react';
import { REQUESTING } from '../../../constants';
import {
	func,
	string,
	number,
	object
} from 'prop-types';
import style from './style';
import '../../../i18n';
import { withNamespaces } from 'react-i18next';

function Presenter({
	onChangeImage,
	onChangeUserName, 
	onChangeTwitterId, 
	onSubmitImage, 
	onSubmit, 
	error, 
	onChangeComment, 
	twitterId, 
	userName, 
	comment, 
	imageUrl, 
	uploadState,
	uploadError,
	uploadProgress,
	id, 
	t }) {
	const Avatar = () => {
		if(uploadState===REQUESTING.FETCHING){
			return <style.Avatar src={`https://via.placeholder.com/400x400?text=Uploading...${uploadProgress}%`} />;
		}
		else if(uploadState===REQUESTING.FAIL){
			return (
				<style.ErrorMessage>
					<style.Avatar src={'https://via.placeholder.com/400x400/ffffff/ff0000?text=ERROR'} />
					<div><style.InfoIcon/>{uploadError}</div>
				</style.ErrorMessage>);
		}
		return <style.Avatar src={imageUrl || 'https://via.placeholder.com/400x400'} />;
	};
	return (
		<style.Wrapper>
			<style.Information>
				<style.BasicInformation>
					<style.AvatarWrapper>
						<Avatar/>
					</style.AvatarWrapper>
					<style.ProfileWrapper>
						<div>
							{error && error.meesage}
						</div>
						<style.CaptionLabel>{t('profile.Name')}</style.CaptionLabel>
						<div><style.TextInput onChange={onChangeUserName} value={userName} /></div>
						<style.CaptionLabel>{t('profile.SNSLink')}</style.CaptionLabel>
						<style.TwitterWrapper>
							<div><style.TwitterIcon /></div>
							<label>
								https://twitter.com/
							</label>
							<style.TwitterText value={twitterId} onChange={onChangeTwitterId} placeholder={t('profile.InputAccountId')} />
						</style.TwitterWrapper>

					</style.ProfileWrapper>
				</style.BasicInformation>
				<style.CaptionLabel>{t('profile.ProfileImage')}</style.CaptionLabel>
				<style.UploadDiv>
					<div>
						<input type='file' onChange={onChangeImage} />
					</div>
					<div>
						<style.UploadButton onClick={onSubmitImage(id)}>Upload</style.UploadButton>
					</div>
				</style.UploadDiv>
				<style.ComentWrapper>
					<style.CaptionLabel>{t('profile.Comment')}</style.CaptionLabel>
					<style.Comment value={comment} onChange={onChangeComment} placeholder={t('profile.CommentHere')} />
				</style.ComentWrapper>
			</style.Information>
			<style.ActionButtons>
				<style.SaveButton onClick={onSubmit(id)}><style.SaveIcon />
					{t('profile.Save')}</style.SaveButton>
			</style.ActionButtons>

		</style.Wrapper>
	);

}

Presenter.propTypes = {
	onChangeImage: func.isRequired,
	onSubmitImage: func.isRequired,
	onChangeUserName: func.isRequired,
	onChangeTwitterId: func.isRequired,
	onSubmit: func.isRequired,
	onChangeComment: func.isRequired,
	imageUrl: string,
	userName: string,
	twitterId: string,
	uploadState :string,
	uploadError : string,
	uploadProgress : number,
	error: object,
	comment: string,
	id: string,
	t: func.isRequired,
};

export default withNamespaces()(Presenter);